import {
  isComplianceRegimeSlug,
  regimeServesCustomers,
  SIGNUP_REGIME_PARAM,
} from "@vidimo/shared";
import { Info } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useTranslations } from "use-intl";
import { Alert, AlertDescription } from "@/components/ui/alert";

/**
 * Names the filing Vidimo does not do yet, for a host who reached signup from a
 * compliance page still waiting on its connector. That page said so in its
 * hero, its disclaimer and its FAQ; this repeats it before the account exists,
 * so the host never learns of the gap only after signing up.
 *
 * The regime arrives on the trial link (`?regime=siba`) because signup knows
 * nothing else about the host yet. Anything the shared table cannot name
 * renders nothing, as does a regime that serves customers.
 */
export function FilingExceptionNotice() {
  const t = useTranslations("auth.filingExceptionNotice");
  const tLabels = useTranslations("labels");
  const { search } = useLocation();
  const regime = new URLSearchParams(search).get(SIGNUP_REGIME_PARAM);
  if (
    !(regime && isComplianceRegimeSlug(regime)) ||
    regimeServesCustomers(regime)
  ) {
    return null;
  }
  return (
    <Alert className="bg-muted/50" role="note">
      <Info className="h-4 w-4" />
      <AlertDescription className="space-y-1">
        <p className="font-medium">{tLabels(`regimeException.${regime}`)}</p>
        <p className="text-muted-foreground">{t("worksFromDayOne")}</p>
      </AlertDescription>
    </Alert>
  );
}
